namespace GeniuzPOS.SalePromoCamp {
    export class PsPromoActiveHdColumns {
        static columnsKey = 'SalePromoCamp.PsPromoActiveHd';
    }
}
